import React from 'react';
import { useNavigate } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch } from 'store';
import { IArticlesItem } from 'store/slices/articles/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  saveArticlesItem,
  saveArticlesItemAsDraft,
} from 'store/slices/articles/actions';
import { prepareContent } from 'components/form/Content/utils';
import { StatusesEnum } from 'constants/status';
import { LangEnum } from 'constants/lang';

import { ArticlesForm } from './components/ArticlesForm';

export const Add = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onFinish = (values: IArticlesItem) => {
    setIsLoading(true);
    dispatch(saveArticlesItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/articles');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: IArticlesItem) => {
    setIsLoading(true);
    dispatch(saveArticlesItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/articles');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/articles');
  };

  return (
    <MainLayout pageTitle='Создание'>
      <ArticlesForm
        onFinish={onFinish}
        onSaveDraft={onSaveDraft}
        cancelButtonHandler={cancelButtonHandler}
        isDraft
        isLoading={isLoading}
        initialValues={{
          category: null,
          content: prepareContent([]),
          intro: '',
          image: null,
          lang: LangEnum.ru,
          name: '',
          region: null,
          shortDescription: '',
          shortName: '',
          status: StatusesEnum.PUBLISHED,
          tags: [],
        }}
      />
    </MainLayout>
  );
};
